import { render, staticRenderFns } from "./SuitableResourcesNew.vue?vue&type=template&id=3ee377ed&scoped=true"
import script from "./SuitableResourcesNew.vue?vue&type=script&lang=ts"
export * from "./SuitableResourcesNew.vue?vue&type=script&lang=ts"
import style0 from "./SuitableResourcesNew.vue?vue&type=style&index=0&id=3ee377ed&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee377ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ee377ed')) {
      api.createRecord('3ee377ed', component.options)
    } else {
      api.reload('3ee377ed', component.options)
    }
    module.hot.accept("./SuitableResourcesNew.vue?vue&type=template&id=3ee377ed&scoped=true", function () {
      api.rerender('3ee377ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/requests/SuitableResourcesNew.vue"
export default component.exports